import { Crop } from 'react-image-crop';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { Size } from '../../typings/common';
import { State } from '../../typings/state';
import { TDispatchProps, TStateProps } from '../../typings/utils';

import { changeSize, closeModal, CreativeImageCropModalAction, cropComplete, saveModal, setImageSize } from './actions';
import { CreativeImageCropModal, CreativeImageCropModalProps } from './CreativeImageCropModal';

export type StateProps = TStateProps<CreativeImageCropModalProps>;

export type DispatchProps = TDispatchProps<CreativeImageCropModalProps>;

interface OwnProps {
    onClose: () => void;
}

export const mapStateToProps = (state: State): StateProps => {
    const {
        isVisible,
        isLoading,
        error,
        cropData,
        imageData,
        sizeData,
        isEditMode
    } = state.canvasEditor.canvas.creativeImageCropModal;
    const cropSizeData = cropData && sizeData ? cropData[sizeData.selectedSize] : undefined;

    return {
        isVisible,
        isLoading,
        error,
        isEditMode,
        src: imageData ? imageData.src : undefined,
        crop: cropSizeData && cropSizeData.crop,
        minWidth: cropSizeData && cropSizeData.minWidth,
        minHeight: cropSizeData && cropSizeData.minHeight,
        sizes: sizeData && sizeData.sizes,
        selectedSize: sizeData && sizeData.selectedSize
    };
};

const mapDispatchToProps = (dispatch: Dispatch<CreativeImageCropModalAction>, ownProps: OwnProps): DispatchProps => {
    return {
        onClose: (): void => {
            dispatch(closeModal());

            ownProps.onClose();
        },
        onSave: (image: HTMLImageElement): void => {
            dispatch(saveModal(image));
        },
        onCropComplete: (crop: Crop): void => {
            dispatch(cropComplete(crop));
        },
        onImageLoaded: (naturalImageSize: Size): void => {
            dispatch(setImageSize(naturalImageSize));
        },
        onChangeSize: (value: number): void => {
            dispatch(changeSize(value));
        }
    };
};

export const CreativeImageCropModalContainer = connect<StateProps, DispatchProps, OwnProps>(
    mapStateToProps,
    mapDispatchToProps
)(CreativeImageCropModal);
